// /api/containers/{terminal_pk}/link_containers/
import axios from './configAxios';

export const putLinkContainersApi = async (terminal_id, requestData) => {
	return axios.put(`/${terminal_id}/link_containers/`, requestData);
};
